var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94291 6.62856C4.31373 6.62856 4.61434 6.32795 4.61434 5.95713C4.61434 5.58632 4.31373 5.28571 3.94291 5.28571C3.57209 5.28571 3.27148 5.58632 3.27148 5.95713C3.27148 6.32795 3.57209 6.62856 3.94291 6.62856Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 5.95712H20.7283",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94291 12.6714C4.31373 12.6714 4.61434 12.3708 4.61434 12C4.61434 11.6292 4.31373 11.3286 3.94291 11.3286C3.57209 11.3286 3.27148 11.6292 3.27148 12C3.27148 12.3708 3.57209 12.6714 3.94291 12.6714Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 12H20.7283",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94291 18.7143C4.31373 18.7143 4.61434 18.4136 4.61434 18.0428C4.61434 17.6721 4.31373 17.3714 3.94291 17.3714C3.57209 17.3714 3.27148 17.6721 3.27148 18.0428C3.27148 18.4136 3.57209 18.7143 3.94291 18.7143Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 18.0428H20.7283",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDisplay);
export default __webpack_public_path__ + "static/media/list_display.b8fc46c3a4900af877456d185835fc1f.svg";
export { ForwardRef as ReactComponent };